export default remote => ({
    get: (code) => remote.get(`short-link/${code}`)
});
